import { MapGroupId } from "../../types";
import img from "../../mapImages/ReserveKeysAndDoors.webp";

const mapData = {
  groupId: MapGroupId.Reserve,
  groupName: {
    en: "Reserve",
    ru: "Резерв ",
  },
  title: {
    en: "Keys and Doors",
    ru: "Ключи и двери",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
